var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJnt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#0050DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 14.625C8.63506 14.6248 8.27686 14.5267 7.96275 14.3409L4.97813 12.5859C4.66031 12.3969 4.39721 12.1283 4.21474 11.8067C4.03227 11.485 3.93672 11.1214 3.9375 10.7516V7.24725C3.93758 6.87778 4.0335 6.51464 4.2159 6.19333C4.3983 5.87202 4.66093 5.60352 4.97813 5.41406L7.96275 3.65906C8.27859 3.47348 8.63818 3.37542 9.0045 3.375C9.36731 3.375 9.7245 3.47288 10.0373 3.65906L13.0219 5.41463C13.3395 5.60358 13.6025 5.87197 13.785 6.19339C13.9674 6.51482 14.0631 6.87821 14.0625 7.24781V10.7522C14.0625 11.1218 13.9666 11.485 13.7842 11.8064C13.6018 12.1278 13.3392 12.3964 13.0219 12.5859L10.0373 14.3409C9.72225 14.5266 9.3645 14.625 9 14.625ZM7.28325 11.0087L6.73031 11.5712C6.87285 11.7189 7.04394 11.8361 7.23319 11.9155C7.42243 11.995 7.62587 12.0352 7.83113 12.0336C8.69175 12.0324 9.39038 11.3226 9.3915 10.4456V9.96638C9.62775 10.1053 9.89606 10.1784 10.1689 10.1779C10.3746 10.1817 10.5789 10.1432 10.7691 10.0646C10.9593 9.98601 11.1312 9.86909 11.2742 9.72112L10.7218 9.15862C10.5756 9.30825 10.3764 9.39262 10.1689 9.39262C9.96095 9.3904 9.76239 9.30585 9.61668 9.15751C9.47097 9.00916 9.39 8.80912 9.3915 8.60119V5.95969H8.61413V10.4507C8.61413 10.8889 8.26538 11.2438 7.83506 11.2438C7.73204 11.2435 7.63012 11.2225 7.53534 11.1821C7.44056 11.1418 7.35484 11.0828 7.28325 11.0087Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJnt);
export default __webpack_public_path__ + "static/media/jnt.5f8c73f7e12b8512f05e3a4a3f22b16d.svg";
export { ForwardRef as ReactComponent };